import React, { useEffect, useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { AmountFormat } from "components/common/formatter";
import { Tile } from "components/UIComponents/Tile";

const MoneyOnAccountDialog = ({ open, clientBalance, value, onClose, onApply }) => {
  const [draftValue, setDraftValue] = useState(value ?? 0);

  useEffect(() => {
    if (open) setDraftValue(value ?? 0);
  }, [open, value]);

  if (!open) return null;

  const handleApply = () => {
    const amount = Math.max(draftValue ?? 0, 0);
    onApply(amount);
  };

  return (
    <Dialog title="Money on Account" onClose={onClose} width={350}>
      <div className="p-3">
        <Tile className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <Label className="label fw-bold">Client Balance:</Label>
            <span className="text-muted">{AmountFormat(clientBalance)}</span>
          </div>
          <Label className="label mb-2 d-block fw-bold">Money on Account</Label>
          <NumericTextBox
            className="right-align"
            format="n2"
            spinners={false}
            min={0}
            value={draftValue}
            onChange={(e) => setDraftValue(e.value ?? 0)}
          />
        </Tile>
      </div>
      <div className="dialog-footer d-flex justify-content-end gap-2 p-3">
        <Button className="common-btn bgBtnSecondary" onClick={onClose}>
          Cancel
        </Button>
        <Button className="common-btn" onClick={handleApply}>
          Add
        </Button>
      </div>
    </Dialog>
  );
};

export default MoneyOnAccountDialog;
